var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetDefaultQuota(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#313131"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09091 6C6.53864 6 6 6.5386 6 7.09091V16.9091C6 17.4614 6.53864 18 7.09091 18H12V17C9.23859 17 7 14.7614 7 12C7 9.23859 9.23859 7 12 7V6H7.09091Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5832 9.50006C11.5832 9.61511 11.49 9.70844 11.3749 9.70844C11.2598 9.70844 11.1666 9.61511 11.1666 9.50006C11.1666 9.38501 11.2598 9.29175 11.3749 9.29175C11.49 9.29175 11.5832 9.38501 11.5832 9.50006Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11.75C10.5 11.8881 10.3881 12 10.25 12C10.1119 12 10 11.8881 10 11.75C10 11.6119 10.1119 11.5 10.25 11.5C10.3881 11.5 10.5 11.6119 10.5 11.75Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3332 13.8751C10.3332 13.9901 10.24 14.0834 10.1249 14.0834C10.0098 14.0834 9.91656 13.9901 9.91656 13.8751C9.91656 13.76 10.0098 13.6667 10.1249 13.6667C10.24 13.6667 10.3332 13.76 10.3332 13.8751Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.625C9.58374 7.625 7.625 9.58374 7.625 12C7.625 14.4163 9.58374 16.375 12 16.375V14.9578C11.6264 14.7417 11.375 14.3377 11.375 13.875C11.375 13.4123 11.6264 13.0083 12 12.7922V9.5V7.625ZM12 9.5C12 9.15485 11.7202 8.875 11.375 8.875C11.0298 8.875 10.75 9.15485 10.75 9.5C10.75 9.84515 11.0298 10.125 11.375 10.125C11.7202 10.125 12 9.84515 12 9.5ZM11 11.75C11 12.1642 10.6642 12.5 10.25 12.5C9.83578 12.5 9.5 12.1642 9.5 11.75C9.5 11.3358 9.83578 11 10.25 11C10.6642 11 11 11.3358 11 11.75ZM10.125 14.5C10.4702 14.5 10.75 14.2202 10.75 13.875C10.75 13.5298 10.4702 13.25 10.125 13.25C9.77982 13.25 9.5 13.5298 9.5 13.875C9.5 14.2202 9.77982 14.5 10.125 14.5Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6.5H18V7H12.5V6.5Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8H18V8.5H12.5V8Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7H17V8H12.5V7Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7H18V8H17.5V7Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10H18V11H17.5V10Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10H14V11H12.5V10Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11H18V11.5H12.5V11Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.5H18V10H12.5V9.5Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 13H18V14H17.5V13Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13H16.5V14H12.5V13Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14H18V14.5H12.5V14Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.5H18V13H12.5V12.5Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 16H15.5V17H12.5V16Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 16H18V17H17.5V16Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17H18V17.5H12.5V17Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.5H18V16H12.5V15.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetDefaultQuota);
export default __webpack_public_path__ + "static/media/SetDefaultQuota.97e1b3fc917c5fd854d1e3b23cfb154b.svg";
export { ForwardRef as ReactComponent };